import { Module } from "vuex";
import RoamingService from "@/services/roaming.service";
import { RoamingCountryStruct, RoamingZoneStruct } from "@/struct/RoaminStruct";
import type { RootState } from "@/store";

export interface RoamingState {
  selectedZone: RoamingZoneStruct | null;
  othersCountriesList: RoamingCountryStruct[] | null;
  othersCountriesCount: number;
  popularCountries: RoamingCountryStruct[] | null;
  searchCountries: RoamingCountryStruct[] | null;
}

const roamingService = new RoamingService();

const roamingModule: Module<RoamingState, RootState> = {
  namespaced: true,
  state: () => ({
    selectedZone: null,
    othersCountriesList: null,
    othersCountriesCount: 0,
    popularCountries: null,
    searchCountries: null,
  }),
  getters: {},
  mutations: {
    SET_SELECTED_ZONE(state, payload: RoamingZoneStruct | null) {
      state.selectedZone = payload;
    },
    SET_SEARCH_COUNTRIES(state, payload: RoamingCountryStruct[]) {
      state.searchCountries = payload;
    },
    SET_OTHERS_COUNTRIES(
      state,
      payload: { countries: RoamingCountryStruct[]; count: number }
    ) {
      state.othersCountriesList = payload.countries;
      state.othersCountriesCount = payload.count;
    },
    CLEAR_OTHERS_COUNTRIES(state) {
      state.othersCountriesList = null;
      state.othersCountriesCount = 0;
    },
    SET_POPULAR_COUNTRIES(state, payload: RoamingCountryStruct[]) {
      state.popularCountries = payload;
    },
  },
  actions: {
    fetchPopularCountries({ commit }) {
      return roamingService
        .GetCountries("", true)
        .then((countries) => {
          commit("SET_POPULAR_COUNTRIES", countries);
        })
        .catch((err) => {
          console.log("Error get popular counters: ", err);
        });
    },
    fetchSearchCountries({ commit }, search: string) {
      return roamingService
        .GetCountries(search)
        .then((countries) => {
          commit("SET_SEARCH_COUNTRIES", countries);
        })
        .catch((err) => {
          console.log("error get counters", err);
        });
    },

    fetchZone({ commit }, uuidZone: string) {
      return roamingService
        .GetZoneByUuid(uuidZone)
        .then((zone) => {
          commit("SET_SELECTED_ZONE", zone);
        })
        .catch((err) => {
          commit("SET_SELECTED_ZONE", null);
          console.log("error get counters", err);
        });
    },

    fetchOthersCountries({ commit }, uuidZone: string) {
      return roamingService
        .GetCountriesByZone(uuidZone)
        .then((data) => {
          commit("SET_OTHERS_COUNTRIES", {
            countries: data.countries,
            count: data.count,
          });
        })
        .catch((err) => {
          commit("CLEAR_OTHERS_COUNTRIES");
          console.log("error get others counters", err);
        });
    },

    resetZoneSelection({ commit }) {
      commit("SET_SELECTED_ZONE", null);
      commit("CLEAR_OTHERS_COUNTRIES");
    },
  },
};

export default roamingModule;
